export default "__VITE_ASSET__1bb51b15__"